<script setup lang="ts">
    import { defaultAutocompleteConverter } from "@/components/forms/inputs/Autocomplete/helpers";
    import KAutocomplete from "@/components/forms/inputs/Autocomplete/KAutocomplete.vue";
    import { defineEmits, defineProps, toRefs, withDefaults } from "vue";

    interface Props {
        name: string;
    }

    const props = withDefaults(defineProps<Props>(), {});
    const emit = defineEmits<{
        (e: "inputValue", value: any): void;
    }>();

    const { name } = toRefs(props);
</script>

<template>
    <KAutocomplete
        :name="name"
        @inputValue="emit('inputValue', $event)"
        v-bind="$attrs"
        url="/core/orgunits/"
        :optionMapper="
            ({ id, name }) => ({
                value: id,
                label: name,
            })
        "
        :converter="defaultAutocompleteConverter"
    />
</template>

<style lang="scss" scoped></style>
